import jwtDecode from 'jwt-decode';

export const dateFromTimeStamp = timestamp => new Date(timestamp * 1000);

export const isValidToken = (token) => {
  try {
    jwtDecode(token);
    return true;
  } catch (error) {
    return false;
  }
};

export const decodeToken = (token) => {
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken;
  } catch (error) {
    throw new Error('Invalid token');
  }
};

export const isTokenExpired = (exp) => {
  try {
    // Date.now() funtion return the number of milliseconds since midnight Jan 1 1970
    // but "exp" from server return the number of second since midnight Jan 1 1970
    // so we need to multiplied exp with 1000 to compare
    const expiredAt = exp * 1000;
    const now = Date.now();

    return expiredAt < now;
  } catch (error) {
    return false;
  }
};

export const isTokenNotExpired = exp => !isTokenExpired(exp);

export const getTokenExpiredMilisecond = (exp) => {
  try {
    // Date.now() funtion return the number of milliseconds since midnight Jan 1 1970
    // but "exp" from server return the number of second since midnight Jan 1 1970
    // so we need to multiplied exp with 1000 to compare
    const expiredAt = exp * 1000;
    const now = Date.now();

    return expiredAt - now;
  } catch (error) {
    return null;
  }
};

export const getTokenExpireMinute = exp => getTokenExpiredMilisecond(exp) / (1000 * 60);

/**
 * Process a jwt token and a a public key.
 * Validates the token and returns the data structure for use in localstorage.
 *
 */
export const processJwt = (token, refreshToken) => {
  const localData = { token, refreshToken };
  const d1 = jwtDecode(token); const
    d2 = jwtDecode(refreshToken);

  localData.tokenExpiration = dateFromTimeStamp(d1.exp);
  localData.refreshTokenExpiration = dateFromTimeStamp(d2.exp);

  return Object.assign(localData, d1);
};
